import { graphql } from "@/lib/gql/__generated__";

export const VoucherListByHotelID_TopPage_Query = graphql(`
	query VoucherListByHotelID_TopPage($hotelID: ID!) {
		voucherListByHotelID(hotelID: $hotelID) {
			id
			voucherList {
				id
				hotelID
				voucherID
				inSale
				name
				description
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				voucherPrice {
					currencyType
					amount
				}
				sellingPrice {
					currencyType
					amount
				}
				saleTypeForTerm
				saleStart
				saleEnd
				maxStockNum
				soldNumTotal
				voucherLimitType
				intervalPrepDates
				cinStart
				cinEnd
				deletedAt
			}
		}
	}
`);
